var module = angular.module('octopusApp.configuration');

module.controller('UserEditController', function($scope, $location, $stateParams, octoDialog, busy, octopusRepository, octopusClient) {
  var isLoading = $scope.isLoading = busy.create();
  var isSaving = $scope.isSaving = busy.create();
  var userId = $stateParams["id"];

  isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function(status) {
    $scope.status = status;

    if (userId) {
      isLoading.promise(octopusRepository.Users.get(userId).then(function(user){
        $scope.user = user;
        $scope.view = { showPasswordChange: false };
      }));
    } else {
      var root = octopusClient.rootDocument();
      $scope.user = { IsActive: true };
      $scope.view = { showPasswordChange: true };
    }
  }));

  $scope.save = function() {
    if ($scope.user.IsActive && $scope.view.showPasswordChange && !$scope.user.IsService) {
      if ($scope.user.Password !== $scope.view.confirmNewPassword) {
        isSaving.showError('The passwords do not match');
        return;
      }
    } else {
      $scope.user.Password = null;
    }
    isSaving.promise(octopusRepository.Users.save($scope.user).then(function() {
      $location.path('/configuration/users');
    }));
  };

});



//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/users/controllers/user_edit_controller.js
// module id = 408
// module chunks = 1